<template>
  <div class="recharge">
    <div class="flex justify-space-between align-center">
      <h2 class="title"></h2>
      <router-link to="/vehicles" class="link">
        &lt; Regresar
      </router-link>
    </div>
    <div class="card flex dspl-block-sm">
      <section class="card-section grow-1">
        <div class="flex justify-space-between dspl-block-m dspl-block-sm">
          <h3>Recargar saldo</h3>
        </div>
        <RechargeForm />
      </section>
    </div>
  </div>
</template>

<script>
import RechargeForm from '@/components/Recharge/RechargeForm'
import { mapActions } from 'vuex'

export default {
  name: 'CERecharge',
  components: {
    RechargeForm
  },
  async beforeMount () {
    await this.getRechargeProductsList()
  },
  destroyed () {
    this.clearRechargeFormState()
  },
  methods: {
    ...mapActions('products', [
      'getRechargeProductsList'
    ]),
    ...mapActions('rechargeForm', [
      'clearRechargeFormState'
    ])
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

.recharge {
  color: $grey;
  text-align: start;
  margin: 1rem 2rem;
}

.title {
  text-align: start;
  color: $grey;
}

.link {
  color: $blue;
  text-decoration: none;
  font-style: italic;
}

.card {
  border-radius: 25px;
  background-color: $white;
  width: 60%;
}

.card-section {
  padding: 1.25rem 2rem;
}

@media (max-width: 60rem) {
  .link {
    display: none;
  }

  .card {
    width: 100%;
  }

  h2 {
    font-size: 1.25rem;
  }
}
</style>
